<div
  class="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
  <div class="loader"></div>
</div>
